import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Field } from "../bits";

export function JoinGroupDialog({ open, onClose, onDone }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.post("/groups/join", { code }); toast.success(`Welcome to ${data.name}`); onDone?.(); onClose(); nav(`/app/groups/${data.id}`); }
    catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-[22px]" data-testid="join-group-dialog">
        <DialogHeader><DialogTitle className="text-nini-heading">Join a group</DialogTitle><DialogDescription>Enter the invitation code shared by the group admin.</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Invitation code"><input data-testid="join-code-input" className="field uppercase tracking-widest font-semibold" value={code} onChange={(e) => setCode(e.target.value)} placeholder="e.g. HOUSE24" required /></Field>
          <button className="btn-primary w-full" data-testid="join-submit-btn" disabled={busy}>{busy ? "Joining..." : "Join group"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
